import React, { Component } from 'react'
import T from 'i18n-react'

import TableComponent from 'components/custom/TableV2'

import CollapsableCard from 'components/custom/Card/CollapsableCard'

import buildProgressHoc from 'containers/Async/AsyncProgressBarHoc'

import { FETCH_WEEKLY_STATUS_REPORT } from "./constants";

const Table = buildProgressHoc(TableComponent)([FETCH_WEEKLY_STATUS_REPORT])


const tableHeadContent = {
  projectId: 'Project ID',
  projectName: 'Project Name',
  partnerSiteName: 'Partner Site',
  lifecycle: 'Lifecycle',
  workWeek: 'Work Week',
  workYear: 'Work Year',
  weekStatus: 'Status',
  userName: 'User',
  role: 'Role'
}

const ReportSummaryCard = ({ reportSource, tableFilter, tableSort, sku, onInputChange, searchFilter, removeFilter, onClearFilters, onRowClick, onMenuSubmit }) => (
  <CollapsableCard title={T.translate('containers.report.weeklystatus.table.header')} collapse={true} onRefresh={onClearFilters}>
    {sku ? <Table
      selectable={false}
      source={reportSource}
      onRowClick={onRowClick}
      onInputChange={onInputChange}
      searchFilter={searchFilter}
      removeFilter={removeFilter}
      onMenuSubmit={onMenuSubmit}
      tableFilter={tableFilter}
      tableSort={tableSort}
      tableHeadContent={tableHeadContent}
      csvFilename={sku + '_weekly_report.csv'}
    /> : <div></div>}
  </CollapsableCard>
)

export default ReportSummaryCard